import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'student-mastery-pullup',
})

export default class StudentMasteryReport extends Vue {
    @Prop()
    private selectedTitle!: string;

    @Prop()
    private type!: any;

    @Prop()
    private selectedCompetency!: any;

    get fieldsItems() {
        return [
            {
                key: 'displayTitle',
                label: this.selectedTitle,
                thClass: this.type,
            },
            {
                key: 'masteryPercent',
                label: '% of Students who attained mastery',
            },
        ];
    }

    public created() {
        this.selectedCompetency.map((item: any) => {
            item.masteryPercent = `${Math.round(item.mastery_percentage)}%`;
            item.displayTitle = `${item.competency_display_code} - ${item.title}`;
        });
    }

}
